// extracted by mini-css-extract-plugin
module.exports = {"lia-content-heading":"NodeListForSearchTerm_lia-content-heading__KgZWR","lia-empty-state-description":"NodeListForSearchTerm_lia-empty-state-description__66B9a"};